export default __webpack_public_path__ + "static/media/logo-primary.97900704.png";